const ITEMS = [
  "Soulever",
  "Déplacer",
  "Éteindre",
  "3 000 kg",
  "Rotation 360°",
  "Chenilles tout-terrain",
  "13–45 cm",
  "IP55",
];

export default function EditorialMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="bg-[#0A0A0A] border-y border-black py-8 lg:py-12 overflow-hidden select-none"
    >
      <div className="flex w-max animate-marquee-slow items-center gap-10 lg:gap-16">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10 lg:gap-16 shrink-0">
            <span
              className={`font-display text-5xl lg:text-7xl font-black uppercase tracking-tight whitespace-nowrap ${
                i % 2 === 0 ? "text-white" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="h-3 w-3 lg:h-4 lg:w-4 rotate-45 bg-[#E63946] shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
